/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateJobLinkedItemModal_job$ref: FragmentReference;
declare export opaque type AddUpdateJobLinkedItemModal_job$fragmentType: AddUpdateJobLinkedItemModal_job$ref;
export type AddUpdateJobLinkedItemModal_job = {|
  +id: string,
  +linkedItems: {|
    +edges: ?$ReadOnlyArray<?{|
      +usageQty: ?number,
      +node: {|
        +id: string,
        +name: string,
      |},
    |}>
  |},
  +$refType: AddUpdateJobLinkedItemModal_job$ref,
|};
export type AddUpdateJobLinkedItemModal_job$data = AddUpdateJobLinkedItemModal_job;
export type AddUpdateJobLinkedItemModal_job$key = {
  +$data?: AddUpdateJobLinkedItemModal_job$data,
  +$fragmentRefs: AddUpdateJobLinkedItemModal_job$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddUpdateJobLinkedItemModal_job",
  "type": "Job",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "linkedItems"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": "linkedItems",
      "name": "__Job_linkedItems_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "JobLinkedItemConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "JobLinkedItemEdge",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "usageQty",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '315779d5a0f287414e6f05a8128b859f';
module.exports = node;
